/* Teanium custom: Menu page · Progressive Steeps controller
   Self-contained state machine — one instance per [data-tn-steeps] container.
   Intercepts container clicks (stopPropagation) so teanium-menu.js document
   handler is bypassed for the steeps widget without touching that file.
   2026-07-10 */
(function () {
  'use strict';

  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function formatTime(sec) {
    if (sec < 0) sec = 0;
    var m = Math.floor(sec / 60);
    var s = Math.round(sec % 60);
    if (s === 60) { m += 1; s = 0; }
    return m + ':' + pad2(s);
  }

  // Shared AudioContext unlocked on first user gesture (iOS Safari fix)
  var _audioCtx = null;
  function _unlockAudio() {
    if (_audioCtx) {
      if (_audioCtx.state === 'suspended') _audioCtx.resume();
      return;
    }
    try {
      _audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {}
  }

  function TNSteeps(root) {
    var circleEls = root.querySelectorAll('[data-tn-steep]');
    this.root    = root;
    this.series  = [];
    this.circles = [];
    for (var i = 0; i < circleEls.length; i++) {
      this.series.push(parseInt(circleEls[i].dataset.seconds, 10) || 0);
      this.circles.push(circleEls[i]);
    }

    this.stepIdx      = 0;
    this.state        = 'idle';
    this.intervalId   = null;
    this.startMs      = 0;
    this.durationSec  = 0;
    this.remainSec    = 0;

    this._displayEl   = root.querySelector('[data-tn-steeps-display]');
    this._displayWrap = root.querySelector('.tn-steeps-display');
    this._labelEl     = root.querySelector('.tn-steeps-display__label');
    this._completeEl  = root.querySelector('[data-tn-steeps-complete]');
    this._startBtn    = root.querySelector('[data-steep-start]');
    this._startLbl    = root.querySelector('[data-steep-start-label]');
    this._resetBtn    = root.querySelector('[data-steep-reset]');

    this._bind();
    // JS ensures display shows first steep's time (Liquid already sets it server-side;
    // this handles any edge case where JS re-initialises after a section reload)
    if (this._displayEl && this.series.length > 0) {
      this._displayEl.textContent = formatTime(this.series[0]);
    }
    this._syncCircles();
    this._syncLabel();
  }

  TNSteeps.prototype._bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      // Own all clicks within the steeps container — prevents teanium-menu.js
      // document-level delegated handler from also firing on circle taps
      e.stopPropagation();

      if (e.target.closest('[data-steep-start]')) {
        if (self.state === 'running') { self.pause(); return; }
        if (self.state === 'paused')  { self.resume(); return; }
        if (self.state === 'idle')    { self.start(); return; }
        return;
      }
      if (e.target.closest('[data-steep-reset]')) {
        self.reset(); return;
      }
      if (e.target.closest('[data-tn-steeps-reset]')) {
        self.reset(); return;
      }
      if (e.target.closest('[data-tn-steeps-display]')) {
        if (self.state !== 'idle') self.reset();
        return;
      }

      var step = e.target.closest('[data-tn-steep]');
      if (!step) return;
      if (step.classList.contains('is-active')) {
        if (self.state === 'running') self.pause();
        else if (self.state === 'paused') self.resume();
      } else if (step.classList.contains('is-ready')) {
        self.start();
      }
    });
  };

  TNSteeps.prototype._syncCircles = function () {
    var idx   = this.stepIdx;
    var state = this.state;
    for (var i = 0; i < this.circles.length; i++) {
      var c = this.circles[i];
      c.classList.remove('is-ready', 'is-active', 'is-done', 'is-paused');
      if (state === 'finished') {
        c.classList.add('is-done');
      } else if (i < idx) {
        c.classList.add('is-done');
      } else if (i === idx) {
        if (state === 'idle')    c.classList.add('is-ready');
        if (state === 'running') c.classList.add('is-active');
        if (state === 'paused')  c.classList.add('is-active', 'is-paused');
      }
    }
  };

  TNSteeps.prototype._syncLabel = function () {
    if (!this._startLbl) return;
    if (this.state === 'running') { this._startLbl.textContent = 'Pause'; return; }
    if (this.state === 'paused')  { this._startLbl.textContent = 'Resume'; return; }
    this._startLbl.textContent = 'Start ' + (this.stepIdx + 1) + '/' + this.series.length;
  };

  TNSteeps.prototype.start = function () {
    _unlockAudio(); // iOS Safari: unlock AudioContext during user gesture
    this.durationSec = this.series[this.stepIdx] || 0;
    this.remainSec   = this.durationSec;
    this.startMs     = performance.now();
    this.state       = 'running';

    if (this._labelEl)   this._labelEl.hidden = true;
    if (this._displayEl) this._displayEl.classList.remove('is-paused');
    if (this._resetBtn)  this._resetBtn.removeAttribute('hidden');

    this._syncCircles();
    this._syncLabel();
    this._startInterval();
  };

  TNSteeps.prototype.resume = function () {
    _unlockAudio(); // iOS Safari: re-unlock if context was suspended
    this.startMs     = performance.now();
    this.durationSec = this.remainSec;
    this.state       = 'running';

    if (this._displayEl) this._displayEl.classList.remove('is-paused');
    this._syncCircles();
    this._syncLabel();
    this._startInterval();
  };

  TNSteeps.prototype._startInterval = function () {
    var self = this;
    this._tick(); // immediate first update
    this.intervalId = setInterval(function () { self._tick(); }, 200);
  };

  TNSteeps.prototype._tick = function () {
    var elapsed = (performance.now() - this.startMs) / 1000;
    this.remainSec = Math.max(0, this.durationSec - elapsed);

    if (this._displayEl) this._displayEl.textContent = formatTime(this.remainSec);

    var circle = this.circles[this.stepIdx];
    if (circle) {
      var total = this.series[this.stepIdx] || 1;
      circle.style.setProperty('--tn-progress', (this.remainSec / total).toFixed(4));
    }

    if (this.remainSec <= 0.05) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this._finish();
    }
  };

  TNSteeps.prototype.pause = function () {
    if (this.intervalId) { clearInterval(this.intervalId); this.intervalId = null; }
    this.state = 'paused';
    if (this._displayEl) this._displayEl.classList.add('is-paused');
    this._syncCircles();
    this._syncLabel();
  };

  TNSteeps.prototype._finish = function () {
    if (this.intervalId) { clearInterval(this.intervalId); this.intervalId = null; }

    this._chime();
    this._flash();
    if (navigator.vibrate) { try { navigator.vibrate([180, 70, 180]); } catch (e) {} }

    if (this.stepIdx < this.series.length - 1) {
      // Mark current step done, advance to next
      var done = this.circles[this.stepIdx];
      if (done) done.style.removeProperty('--tn-progress');
      this.stepIdx++;
      this.state     = 'idle';
      this.remainSec = 0;
      this._syncCircles();
      if (this._displayEl) {
        this._displayEl.classList.remove('is-paused');
        this._displayEl.textContent = formatTime(this.series[this.stepIdx] || 0);
      }
      this._syncLabel();
    } else {
      // All steeps complete
      this.state = 'finished';
      if (this._displayEl) {
        this._displayEl.textContent = '0:00';
        this._displayEl.classList.remove('is-paused');
      }
      this._syncCircles();
      if (this._completeEl) this._completeEl.hidden = false;
      if (this._startBtn)   this._startBtn.hidden = true;
    }
  };

  TNSteeps.prototype._chime = function () {
    try {
      var ctx = _audioCtx;
      if (!ctx || ctx.state !== 'running') return;
      var osc  = ctx.createOscillator();
      var gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.setValueAtTime(660, ctx.currentTime);
      osc.frequency.setValueAtTime(880, ctx.currentTime + 0.12);
      gain.gain.setValueAtTime(0.25, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.5);
    } catch (e) {}
  };

  TNSteeps.prototype._flash = function () {
    var wrap = this._displayWrap;
    if (!wrap) return;
    wrap.classList.add('tn-steeps-display--flash');
    setTimeout(function () { wrap.classList.remove('tn-steeps-display--flash'); }, 600);
  };

  TNSteeps.prototype.reset = function () {
    if (this.intervalId) { clearInterval(this.intervalId); this.intervalId = null; }

    this.state     = 'idle';
    this.stepIdx   = 0;
    this.remainSec = 0;

    for (var i = 0; i < this.circles.length; i++) {
      this.circles[i].style.removeProperty('--tn-progress');
    }

    if (this._displayEl) {
      this._displayEl.classList.remove('is-paused');
      this._displayEl.textContent = formatTime(this.series[0] || 0);
    }
    if (this._labelEl)   this._labelEl.hidden = false;
    if (this._completeEl) this._completeEl.hidden = true;
    if (this._resetBtn)  this._resetBtn.setAttribute('hidden', '');
    if (this._startBtn)  this._startBtn.removeAttribute('hidden');

    this._syncCircles();
    this._syncLabel();
  };

  function init() {
    var nodes = document.querySelectorAll('[data-tn-steeps]');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i]._tnSteepsCtrl) {
        nodes[i]._tnSteepsCtrl = new TNSteeps(nodes[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
